import { ChangeDetectionStrategy,Component } from '@angular/core';

@Component({
    selector: 'admin-signin',
    changeDetection: ChangeDetectionStrategy.Eager,
    template: ''
})
export class SignInPageComponent {}
